import type { SessionStepModule } from '../types';
import { GstDetail } from './GstDetail';
import { GstStepRunner } from './GstStepRunner';
import { isGstStep } from './gst.utils';

// GST Verification step module (Basic / Advance).
export const gstStepModule: SessionStepModule = {
  key: 'gst',
  matches: isGstStep,
  Runner: GstStepRunner,
  Detail: GstDetail,
};
